import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { connect, useSelector } from "react-redux";
import MostEngagedContainer from "./MostEngagedContainer";
import { IArticlesItem } from "../../../Content/interfaces";
import store, { RootState } from "../../../../store/index";
import { getMostEngaged } from "../actions";
import { chunkArray } from "../../../../utils";
import MyAccountsArticles from "../../MyAccounts/Components/myAccountsArticles";
import InfiniteLoader from "../../../Common/Components/InfiniteLoader";
import ListPlaceholder from "../../WhatsHappeningNow/Components/ListPlaceholder";
import MyAccountsPlaceHolder from "../../../Content/MyAccounts/Components/MyAccountsPlaceHolder";

// styles goes here
import styled from "styled-components";
import EmptyTabInfo from "modules/Content/Shared/EmptyTabInfo";
import SelectedBottom from "modules/Common/Components/SelectedBottom";
import { removeSelectedIds } from "modules/Content/DragnDrop/actions";
import { PREVIEW_ARTICLE } from "constants/actionTypes";

interface IMostEngagedTabProps {
  isListView: boolean;
}

const MostEngagedTab = (props: IMostEngagedTabProps) => {
  const { isListView } = props;
  const DEFAULT_PAGE_LIMIT = 21;
  const FIRST_PAGE_LIMIT = 16;

  const articles: IArticlesItem[] = useSelector((state: RootState) => state.mostEngaged.data);
  const loading: boolean = useSelector((state: RootState) => state.mostEngaged.loading);
  const page: number = useSelector((state: RootState) => state.mostEngaged.page);
  const selectedIds = useSelector((state: RootState) => state.dragDrop.selectedIds);

  const getPagination = () => {
    let offset = page > 0 ? articles.length : 0;
    let limit = page > 0 ? DEFAULT_PAGE_LIMIT : FIRST_PAGE_LIMIT; //update to 22

    return { result_offset: offset, result_limit: limit };
  };

  useEffect(() => {
    if (articles.length === 0) getMostEngaged(getPagination());
    store.dispatch({
      type: PREVIEW_ARTICLE.RESET_SEARCH_TERMS,
    });
  }, []);

  if (articles.length === 0 && page > 0) {
    return (
      <div className="padding-top-xl">
        <EmptyTabInfo
          description="Once you start creating assets and sending them to your contacts, we’ll populate this page with your most engaged content — so you can see what’s working with your audience"
          btntext="Back to What's Happening Now"
          url="/content/explorer"
        />
      </div>
    );
  }

  return (
    <MostEngagedStyle>
      <InfiniteLoader
        dataLength={articles.length}
        next={() => getMostEngaged(getPagination())}
        hasMore={true}
        loader={
          isListView ? (
            <ListPlaceholder loading={loading} />
          ) : (
            <div className="padding-top-md">
              <MyAccountsPlaceHolder loading={loading} />
            </div>
          )
        }
      >
        <div className="margin-top-sm">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
            <Col className="gutter-row" span={17}>
              <h2 className="accounts-title">Most engaged content over last 7 days:</h2>
            </Col>
          </Row>

          {articles.length ? (
            <MostEngagedContainer articles={articles.slice(0, FIRST_PAGE_LIMIT)} isListView={isListView} />
          ) : null}

          {chunkArray(articles.slice(FIRST_PAGE_LIMIT), DEFAULT_PAGE_LIMIT).map((subArtilces, index) => (
            <MyAccountsArticles key={index} articles={subArtilces} isListView={isListView} />
          ))}
        </div>
      </InfiniteLoader>
      <SelectedBottom
        hideAction={true}
        selectedCount={selectedIds?.length}
        selectedMessage={` ${selectedIds.length === 1 ? "article" : "articles"} selected`}
        onClearSelection={removeSelectedIds}
      />
    </MostEngagedStyle>
  );
};

export default connect()(MostEngagedTab);

const MostEngagedStyle = styled.div`
  display: inline-block;
  h2.accounts-title {
    color: #67696a;
    font-size: 22px;
    font-weight: 500;
    font-family: "robotomedium";
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
    span {
      font-family: "robotolight_italic";
      padding-left: 25px;
      font-size: 18px;
      font-weight: 400;
    }
  }
`;
